import React from 'react';

import { IDoc } from '../../../api/investorApi';

import InvestorBlock from '../InvestorBlock';
import ContentList from '../ContentList';
import { CoveredPdfCard } from '../PdfCard';

interface IProps {
  title: string;
  anchor: string;
  data: IDoc[];
}

function CsrReport(props: IProps) {
  const { title, anchor, data } = props;
  return (
    <InvestorBlock linkOut linkUrl="/investor/csr-reports" title={title} anchor={anchor} hasMore>
      <ContentList responsive colNum={4}>
        {data?.map((doc) => {
          return (
            <CoveredPdfCard
              width={523}
              height={678}
              key={doc.id}
              coverImage={doc.coverImage}
              title={doc.title}
              date={doc.date}
              link={doc.link}
            />
          );
        })}
      </ContentList>
    </InvestorBlock>
  );
}

export { CsrReport };
